<mat-expansion-panel [class]="modalData.type"  [expanded]="true" hideToggle >
    <mat-expansion-panel-header  style="pointer-events: none">
      <mat-panel-description>
        {{modalData.title}}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div fxLayoutAlign="center">
      <p class="mt-3 mb-3 breakline">{{modalData.description}}</p>
    </div>
    <div fxLayoutAlign="center">
      <button color="primary" mat-raised-button (click)="closeMe('ok')"> {{ modalData.actionButtonText }}</button>
      <button *ngIf="modalData.ShowCancelButton" class="grey-button" style="margin-left: 10px" mat-raised-button (click)="closeMe('cancel')"> {{ modalData.cancelButtonText }}</button>
    </div>
  </mat-expansion-panel>